module.exports = __webpack_public_path__ + "static/media/solo-people-icon.5f24828c.svg";